import React, { useEffect, useState } from "react";
import iconLogout from "../../resources/themes/dashboard-v1/icons/logout.svg";
import { Link } from "react-router-dom";
import LogoutButton from "./LogoutButton";
import logoBlack from "../../resources/themes/dashboard-v1/img/logo-black.png";
import { circleXIcon } from "../../resources/themes/dashboard-v1/icons/icons";

const icons = {
  Dashboard: (
    <svg
      className="me-3 icon pe-none"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 14.69C6.59 14.69 6.25 14.35 6.25 13.94V10.73C6.25 10.32 6.59 9.97998 7 9.97998C7.41 9.97998 7.75 10.32 7.75 10.73V13.94C7.75 14.36 7.41 14.69 7 14.69Z"
        fill="#5A5A5A"
      />
      <path
        d="M12 16.43C11.59 16.43 11.25 16.09 11.25 15.68V9C11.25 8.59 11.59 8.25 12 8.25C12.41 8.25 12.75 8.59 12.75 9V15.68C12.75 16.09 12.41 16.43 12 16.43Z"
        fill="#5A5A5A"
      />
      <path
        d="M17 14.69C16.59 14.69 16.25 14.35 16.25 13.94V10.73C16.25 10.32 16.59 9.97998 17 9.97998C17.41 9.97998 17.75 10.32 17.75 10.73V13.94C17.75 14.36 17.41 14.69 17 14.69Z"
        fill="#5A5A5A"
      />
      <path
        d="M15 22.75H9C3.57 22.75 1.25 20.43 1.25 15V9C1.25 3.57 3.57 1.25 9 1.25H15C20.43 1.25 22.75 3.57 22.75 9V15C22.75 20.43 20.43 22.75 15 22.75ZM9 2.75C4.39 2.75 2.75 4.39 2.75 9V15C2.75 19.61 4.39 21.25 9 21.25H15C19.61 21.25 21.25 19.61 21.25 15V9C21.25 4.39 19.61 2.75 15 2.75H9Z"
        fill="#5A5A5A"
      />
    </svg>
  ),
  Products: (
    <svg
      className="me-3 icon pe-none"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.19 17.75H7.53999C6.54999 17.75 5.59999 17.33 4.92999 16.6C4.25999 15.87 3.92 14.89 4 13.9L4.83 3.94C4.86 3.63 4.74999 3.33001 4.53999 3.10001C4.32999 2.87001 4.04 2.75 3.73 2.75H2C1.59 2.75 1.25 2.41 1.25 2C1.25 1.59 1.59 1.25 2 1.25H3.74001C4.47001 1.25 5.15999 1.56 5.64999 2.09C5.91999 2.39 6.12 2.74 6.23 3.13H18.72C19.73 3.13 20.66 3.53 21.34 4.25C22.01 4.98 22.35 5.93 22.27 6.94L21.73 14.44C21.62 16.27 20.02 17.75 18.19 17.75ZM6.28 4.62L5.5 14.02C5.45 14.6 5.64 15.15 6.03 15.58C6.42 16.01 6.95999 16.24 7.53999 16.24H18.19C19.23 16.24 20.17 15.36 20.25 14.32L20.79 6.82001C20.83 6.23001 20.64 5.67001 20.25 5.26001C19.86 4.84001 19.32 4.60999 18.73 4.60999H6.28V4.62Z"
        fill="#5A5A5A"
      />
      <path
        d="M16.25 22.75C15.15 22.75 14.25 21.85 14.25 20.75C14.25 19.65 15.15 18.75 16.25 18.75C17.35 18.75 18.25 19.65 18.25 20.75C18.25 21.85 17.35 22.75 16.25 22.75ZM16.25 20.25C15.97 20.25 15.75 20.47 15.75 20.75C15.75 21.03 15.97 21.25 16.25 21.25C16.53 21.25 16.75 21.03 16.75 20.75C16.75 20.47 16.53 20.25 16.25 20.25Z"
        fill="#5A5A5A"
      />
      <path
        d="M8.25 22.75C7.15 22.75 6.25 21.85 6.25 20.75C6.25 19.65 7.15 18.75 8.25 18.75C9.35 18.75 10.25 19.65 10.25 20.75C10.25 21.85 9.35 22.75 8.25 22.75ZM8.25 20.25C7.97 20.25 7.75 20.47 7.75 20.75C7.75 21.03 7.97 21.25 8.25 21.25C8.53 21.25 8.75 21.03 8.75 20.75C8.75 20.47 8.53 20.25 8.25 20.25Z"
        fill="#5A5A5A"
      />
      <path
        d="M21 8.75H9C8.59 8.75 8.25 8.41 8.25 8C8.25 7.59 8.59 7.25 9 7.25H21C21.41 7.25 21.75 7.59 21.75 8C21.75 8.41 21.41 8.75 21 8.75Z"
        fill="#5A5A5A"
      />
    </svg>
  ),
  Services: (
    <svg
      className="me-3 icon pe-none"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 10.75H5C2.58 10.75 1.25 9.42 1.25 7V5C1.25 2.58 2.58 1.25 5 1.25H7C9.42 1.25 10.75 2.58 10.75 5V7C10.75 9.42 9.42 10.75 7 10.75ZM5 2.75C3.42 2.75 2.75 3.42 2.75 5V7C2.75 8.58 3.42 9.25 5 9.25H7C8.58 9.25 9.25 8.58 9.25 7V5C9.25 3.42 8.58 2.75 7 2.75H5Z"
        fill="#5A5A5A"
      />
      <path
        d="M19 10.75H17C14.58 10.75 13.25 9.42 13.25 7V5C13.25 2.58 14.58 1.25 17 1.25H19C21.42 1.25 22.75 2.58 22.75 5V7C22.75 9.42 21.42 10.75 19 10.75ZM17 2.75C15.42 2.75 14.75 3.42 14.75 5V7C14.75 8.58 15.42 9.25 17 9.25H19C20.58 9.25 21.25 8.58 21.25 7V5C21.25 3.42 20.58 2.75 19 2.75H17Z"
        fill="#5A5A5A"
      />
      <path
        d="M19 22.75H17C14.58 22.75 13.25 21.42 13.25 19V17C13.25 14.58 14.58 13.25 17 13.25H19C21.42 13.25 22.75 14.58 22.75 17V19C22.75 21.42 21.42 22.75 19 22.75ZM17 14.75C15.42 14.75 14.75 15.42 14.75 17V19C14.75 20.58 15.42 21.25 17 21.25H19C20.58 21.25 21.25 20.58 21.25 19V17C21.25 15.42 20.58 14.75 19 14.75H17Z"
        fill="#5A5A5A"
      />
      <path
        d="M7 22.75H5C2.58 22.75 1.25 21.42 1.25 19V17C1.25 14.58 2.58 13.25 5 13.25H7C9.42 13.25 10.75 14.58 10.75 17V19C10.75 21.42 9.42 22.75 7 22.75ZM5 14.75C3.42 14.75 2.75 15.42 2.75 17V19C2.75 20.58 3.42 21.25 5 21.25H7C8.58 21.25 9.25 20.58 9.25 19V17C9.25 15.42 8.58 14.75 7 14.75H5Z"
        fill="#5A5A5A"
      />
    </svg>
  ),
  Calendar: (
    <svg
      className="me-3 icon pe-none"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 5.75C7.59 5.75 7.25 5.41 7.25 5V2C7.25 1.59 7.59 1.25 8 1.25C8.41 1.25 8.75 1.59 8.75 2V5C8.75 5.41 8.41 5.75 8 5.75Z"
        fill="#5A5A5A"
      />
      <path
        d="M16 5.75C15.59 5.75 15.25 5.41 15.25 5V2C15.25 1.59 15.59 1.25 16 1.25C16.41 1.25 16.75 1.59 16.75 2V5C16.75 5.41 16.41 5.75 16 5.75Z"
        fill="#5A5A5A"
      />
      <path
        d="M8.5 14.5003C8.37 14.5003 8.24 14.4703 8.12 14.4203C7.99 14.3703 7.89 14.3003 7.79 14.2103C7.61 14.0203 7.5 13.7703 7.5 13.5003C7.5 13.3703 7.53 13.2403 7.58 13.1203C7.63 13.0003 7.7 12.8903 7.79 12.7903C7.89 12.7003 7.99 12.6303 8.12 12.5803C8.48 12.4303 8.93 12.5103 9.21 12.7903C9.39 12.9803 9.5 13.2403 9.5 13.5003C9.5 13.5603 9.49 13.6303 9.48 13.7003C9.47 13.7603 9.45 13.8203 9.42 13.8803C9.4 13.9403 9.37 14.0003 9.33 14.0603C9.3 14.1103 9.25 14.1603 9.21 14.2103C9.02 14.3903 8.76 14.5003 8.5 14.5003Z"
        fill="#5A5A5A"
      />
      <path
        d="M12 14.5008C11.87 14.5008 11.74 14.4708 11.62 14.4208C11.49 14.3708 11.39 14.3008 11.29 14.2108C11.11 14.0208 11 13.7708 11 13.5008C11 13.3708 11.03 13.2408 11.08 13.1208C11.13 13.0008 11.2 12.8908 11.29 12.7908C11.39 12.7008 11.49 12.6308 11.62 12.5808C11.98 12.4208 12.43 12.5108 12.71 12.7908C12.89 12.9808 13 13.2408 13 13.5008C13 13.5608 12.99 13.6308 12.98 13.7008C12.97 13.7608 12.95 13.8208 12.92 13.8808C12.9 13.9408 12.87 14.0008 12.83 14.0608C12.8 14.1108 12.75 14.1608 12.71 14.2108C12.52 14.3908 12.26 14.5008 12 14.5008Z"
        fill="#5A5A5A"
      />
      <path
        d="M15.5 14.5008C15.37 14.5008 15.24 14.4708 15.12 14.4208C14.99 14.3708 14.89 14.3008 14.79 14.2108C14.75 14.1608 14.71 14.1108 14.67 14.0608C14.63 14.0008 14.6 13.9408 14.58 13.8808C14.55 13.8208 14.53 13.7608 14.52 13.7008C14.51 13.6308 14.5 13.5608 14.5 13.5008C14.5 13.2408 14.61 12.9808 14.79 12.7908C14.89 12.7008 14.99 12.6308 15.12 12.5808C15.49 12.4208 15.93 12.5108 16.21 12.7908C16.39 12.9808 16.5 13.2408 16.5 13.5008C16.5 13.5608 16.49 13.6308 16.48 13.7008C16.47 13.7608 16.45 13.8208 16.42 13.8808C16.4 13.9408 16.37 14.0008 16.33 14.0608C16.3 14.1108 16.25 14.1608 16.21 14.2108C16.02 14.3908 15.76 14.5008 15.5 14.5008Z"
        fill="#5A5A5A"
      />
      <path
        d="M8.5 17.9991C8.37 17.9991 8.24 17.9692 8.12 17.9192C8 17.8692 7.89 17.7991 7.79 17.7091C7.61 17.5191 7.5 17.2591 7.5 16.9991C7.5 16.8691 7.53 16.7391 7.58 16.6191C7.63 16.4891 7.7 16.3792 7.79 16.2892C8.16 15.9192 8.84 15.9192 9.21 16.2892C9.39 16.4792 9.5 16.7391 9.5 16.9991C9.5 17.2591 9.39 17.5191 9.21 17.7091C9.02 17.8891 8.76 17.9991 8.5 17.9991Z"
        fill="#5A5A5A"
      />
      <path
        d="M12 17.9991C11.74 17.9991 11.48 17.8891 11.29 17.7091C11.11 17.5191 11 17.2591 11 16.9991C11 16.8691 11.03 16.7391 11.08 16.6191C11.13 16.4891 11.2 16.3792 11.29 16.2892C11.66 15.9192 12.34 15.9192 12.71 16.2892C12.8 16.3792 12.87 16.4891 12.92 16.6191C12.97 16.7391 13 16.8691 13 16.9991C13 17.2591 12.89 17.5191 12.71 17.7091C12.52 17.8891 12.26 17.9991 12 17.9991Z"
        fill="#5A5A5A"
      />
      <path
        d="M15.5 17.9989C15.24 17.9989 14.98 17.8889 14.79 17.7089C14.7 17.6189 14.63 17.5089 14.58 17.3789C14.53 17.2589 14.5 17.1289 14.5 16.9989C14.5 16.8689 14.53 16.7389 14.58 16.6189C14.63 16.4889 14.7 16.3789 14.79 16.2889C15.02 16.0589 15.37 15.9489 15.69 16.0189C15.76 16.0289 15.82 16.0489 15.88 16.0789C15.94 16.0989 16 16.1289 16.06 16.1689C16.11 16.1989 16.16 16.2489 16.21 16.2889C16.39 16.4789 16.5 16.7389 16.5 16.9989C16.5 17.2589 16.39 17.5189 16.21 17.7089C16.02 17.8889 15.76 17.9989 15.5 17.9989Z"
        fill="#5A5A5A"
      />
      <path
        d="M20.5 9.83984H3.5C3.09 9.83984 2.75 9.49984 2.75 9.08984C2.75 8.67984 3.09 8.33984 3.5 8.33984H20.5C20.91 8.33984 21.25 8.67984 21.25 9.08984C21.25 9.49984 20.91 9.83984 20.5 9.83984Z"
        fill="#5A5A5A"
      />
      <path
        d="M16 22.75H8C4.35 22.75 2.25 20.65 2.25 17V8.5C2.25 4.85 4.35 2.75 8 2.75H16C19.65 2.75 21.75 4.85 21.75 8.5V17C21.75 20.65 19.65 22.75 16 22.75ZM8 4.25C5.14 4.25 3.75 5.64 3.75 8.5V17C3.75 19.86 5.14 21.25 8 21.25H16C18.86 21.25 20.25 19.86 20.25 17V8.5C20.25 5.64 18.86 4.25 16 4.25H8Z"
        fill="#5A5A5A"
      />
    </svg>
  ),
  Appointments: (
    <svg
      className="me-3 icon pe-none"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.9994 13.2989C11.8694 13.2989 11.7394 13.2689 11.6194 13.1989L2.78936 8.08892C2.42936 7.87892 2.30934 7.41889 2.51934 7.05889C2.72934 6.69889 3.17934 6.57888 3.54934 6.78888L11.9994 11.6789L20.3993 6.8189C20.7593 6.6089 21.2193 6.73892 21.4293 7.08892C21.6393 7.44892 21.5094 7.9089 21.1594 8.1189L12.3894 13.1989C12.2594 13.2589 12.1294 13.2989 11.9994 13.2989Z"
        fill="#5A5A5A"
      />
      <path
        d="M12 22.3591C11.59 22.3591 11.25 22.0191 11.25 21.6091V12.5391C11.25 12.1291 11.59 11.7891 12 11.7891C12.41 11.7891 12.75 12.1291 12.75 12.5391V21.6091C12.75 22.0191 12.41 22.3591 12 22.3591Z"
        fill="#5A5A5A"
      />
      <path
        d="M12.0006 22.75C11.1206 22.75 10.2506 22.56 9.56061 22.18L4.22062 19.21C2.77062 18.41 1.64062 16.48 1.64062 14.82V9.16998C1.64062 7.50998 2.77062 5.59002 4.22062 4.78002L9.56061 1.82C10.9306 1.06 13.0706 1.06 14.4406 1.82L19.7806 4.78997C21.2306 5.58997 22.3606 7.51999 22.3606 9.17999V14.83C22.3606 16.49 21.2306 18.41 19.7806 19.22L14.4406 22.18C13.7506 22.56 12.8806 22.75 12.0006 22.75ZM12.0006 2.74999C11.3706 2.74999 10.7506 2.88 10.2906 3.13L4.95063 6.09997C3.99063 6.63997 3.14062 8.06999 3.14062 9.17999V14.83C3.14062 15.93 3.99063 17.37 4.95063 17.91L10.2906 20.88C11.2006 21.39 12.8006 21.39 13.7106 20.88L19.0506 17.91C20.0106 17.37 20.8606 15.94 20.8606 14.83V9.17999C20.8606 8.07999 20.0106 6.63997 19.0506 6.09997L13.7106 3.13C13.2506 2.88 12.6306 2.74999 12.0006 2.74999Z"
        fill="#5A5A5A"
      />
      <path
        d="M17.0012 13.9905C16.5912 13.9905 16.2512 13.6505 16.2512 13.2405V10.0206L7.13116 4.76056C6.77116 4.55056 6.65114 4.09054 6.86114 3.74054C7.07114 3.38054 7.52116 3.26052 7.88116 3.47052L17.3712 8.95056C17.6012 9.08056 17.7512 9.33052 17.7512 9.60052V13.2606C17.7512 13.6506 17.4112 13.9905 17.0012 13.9905Z"
        fill="#5A5A5A"
      />
    </svg>
  ),
  Employees: (
    <svg
      className="me-3 icon pe-none"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.16055 11.62C9.13055 11.62 9.11055 11.62 9.08055 11.62C9.03055 11.61 8.96055 11.61 8.90055 11.62C6.00055 11.53 3.81055 9.25 3.81055 6.44C3.81055 3.58 6.14055 1.25 9.00055 1.25C11.8605 1.25 14.1905 3.58 14.1905 6.44C14.1805 9.25 11.9805 11.53 9.19055 11.62C9.18055 11.62 9.17055 11.62 9.16055 11.62ZM9.00055 2.75C6.97055 2.75 5.31055 4.41 5.31055 6.44C5.31055 8.44 6.87055 10.05 8.86055 10.12C8.92055 10.11 9.05055 10.11 9.18055 10.12C11.1405 10.03 12.6805 8.42 12.6905 6.44C12.6905 4.41 11.0305 2.75 9.00055 2.75Z"
        fill="#5A5A5A"
      />
      <path
        d="M16.5404 11.75C16.5104 11.75 16.4804 11.75 16.4504 11.74C16.0404 11.78 15.6204 11.49 15.5804 11.08C15.5404 10.67 15.7904 10.3 16.2004 10.25C16.3204 10.24 16.4504 10.24 16.5604 10.24C18.0204 10.16 19.1604 8.96 19.1604 7.49C19.1604 5.97 17.9304 4.74 16.4104 4.74C16.0004 4.75 15.6604 4.41 15.6604 4C15.6604 3.59 16.0004 3.25 16.4104 3.25C18.7504 3.25 20.6604 5.16 20.6604 7.5C20.6604 9.8 18.8604 11.66 16.5704 11.75C16.5604 11.75 16.5504 11.75 16.5404 11.75Z"
        fill="#5A5A5A"
      />
      <path
        d="M9.16961 22.55C7.20961 22.55 5.23961 22.05 3.74961 21.05C2.35961 20.13 1.59961 18.87 1.59961 17.5C1.59961 16.13 2.35961 14.86 3.74961 13.93C6.74961 11.94 11.6096 11.94 14.5896 13.93C15.9696 14.85 16.7396 16.11 16.7396 17.48C16.7396 18.85 15.9796 20.12 14.5896 21.05C13.0896 22.05 11.1296 22.55 9.16961 22.55ZM4.57961 15.19C3.61961 15.83 3.09961 16.65 3.09961 17.51C3.09961 18.36 3.62961 19.18 4.57961 19.81C7.06961 21.48 11.2696 21.48 13.7596 19.81C14.7196 19.17 15.2396 18.35 15.2396 17.49C15.2396 16.64 14.7096 15.82 13.7596 15.19C11.2696 13.53 7.06961 13.53 4.57961 15.19Z"
        fill="#5A5A5A"
      />
      <path
        d="M18.3402 20.75C17.9902 20.75 17.6802 20.51 17.6102 20.15C17.5302 19.74 17.7902 19.35 18.1902 19.26C18.8202 19.13 19.4002 18.88 19.8502 18.53C20.4202 18.1 20.7302 17.56 20.7302 16.99C20.7302 16.42 20.4202 15.88 19.8602 15.46C19.4202 15.12 18.8702 14.88 18.2202 14.73C17.8202 14.64 17.5602 14.24 17.6502 13.83C17.7402 13.43 18.1402 13.17 18.5502 13.26C19.4102 13.45 20.1602 13.79 20.7702 14.26C21.7002 14.96 22.2302 15.95 22.2302 16.99C22.2302 18.03 21.6902 19.02 20.7602 19.73C20.1402 20.21 19.3602 20.56 18.5002 20.73C18.4402 20.75 18.3902 20.75 18.3402 20.75Z"
        fill="#5A5A5A"
      />
    </svg>
  ),
  Orders: (
    <svg
      className="me-3 icon pe-none"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.9994 13.2999C11.8694 13.2999 11.7394 13.2699 11.6194 13.1999L2.78936 8.0899C2.42936 7.8799 2.30934 7.41987 2.51934 7.05987C2.72934 6.69987 3.17934 6.57985 3.54934 6.78985L11.9994 11.6799L20.3993 6.81988C20.7593 6.60988 21.2193 6.7399 21.4293 7.0899C21.6393 7.4499 21.5094 7.90987 21.1594 8.11987L12.3894 13.1999C12.2594 13.2599 12.1294 13.2999 11.9994 13.2999Z"
        fill="#5A5A5A"
      />
      <path
        d="M12 22.36C11.59 22.36 11.25 22.02 11.25 21.61V12.54C11.25 12.13 11.59 11.79 12 11.79C12.41 11.79 12.75 12.13 12.75 12.54V21.61C12.75 22.02 12.41 22.36 12 22.36Z"
        fill="#5A5A5A"
      />
      <path
        d="M12.0006 22.75C11.1206 22.75 10.2506 22.56 9.56061 22.18L4.22062 19.21C2.77062 18.41 1.64062 16.48 1.64062 14.82V9.16998C1.64062 7.50998 2.77062 5.59002 4.22062 4.78002L9.56061 1.82C10.9306 1.06 13.0706 1.06 14.4406 1.82L19.7806 4.78997C21.2306 5.58997 22.3606 7.51999 22.3606 9.17999V14.83C22.3606 16.49 21.2306 18.41 19.7806 19.22L14.4406 22.18C13.7506 22.56 12.8806 22.75 12.0006 22.75ZM12.0006 2.74999C11.3706 2.74999 10.7506 2.88 10.2906 3.13L4.95063 6.09997C3.99063 6.63997 3.14062 8.06999 3.14062 9.17999V14.83C3.14062 15.93 3.99063 17.37 4.95063 17.91L10.2906 20.88C11.2006 21.39 12.8006 21.39 13.7106 20.88L19.0506 17.91C20.0106 17.37 20.8606 15.94 20.8606 14.83V9.17999C20.8606 8.07999 20.0106 6.63997 19.0506 6.09997L13.7106 3.13C13.2506 2.88 12.6306 2.74999 12.0006 2.74999Z"
        fill="#5A5A5A"
      />
      <path
        d="M17.0012 13.99C16.5912 13.99 16.2512 13.65 16.2512 13.24V10.0201L7.13116 4.76007C6.77116 4.55007 6.65114 4.09005 6.86114 3.74005C7.07114 3.38005 7.52116 3.26003 7.88116 3.47003L17.3712 8.95007C17.6012 9.08007 17.7512 9.33003 17.7512 9.60003V13.2601C17.7512 13.6501 17.4112 13.99 17.0012 13.99Z"
        fill="#5A5A5A"
      />
    </svg>
  ),
  Search: (
    <svg
      className="me-3 icon pe-none"
      width="24"
      height="24"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.58329 18.1251C4.87496 18.1251 1.04163 14.2917 1.04163 9.58342C1.04163 4.87508 4.87496 1.04175 9.58329 1.04175C14.2916 1.04175 18.125 4.87508 18.125 9.58342C18.125 14.2917 14.2916 18.1251 9.58329 18.1251ZM9.58329 2.29175C5.55829 2.29175 2.29163 5.56675 2.29163 9.58342C2.29163 13.6001 5.55829 16.8751 9.58329 16.8751C13.6083 16.8751 16.875 13.6001 16.875 9.58342C16.875 5.56675 13.6083 2.29175 9.58329 2.29175Z"
        fill="#5A5A5A"
      />
      <path
        d="M18.3337 18.9583C18.1753 18.9583 18.017 18.9 17.892 18.775L16.2253 17.1083C15.9837 16.8666 15.9837 16.4666 16.2253 16.225C16.467 15.9833 16.867 15.9833 17.1087 16.225L18.7753 17.8916C19.017 18.1333 19.017 18.5333 18.7753 18.775C18.6503 18.9 18.492 18.9583 18.3337 18.9583Z"
        fill="#5A5A5A"
      />
    </svg>
  ),
  Transfers: (
    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20.03 20.02"
      className="me-3 icon pe-none"
      width="19"
      height="19"
    >
      <g id="g1500">
        <path
          id="path876"
          d="M3.9,8.99H15.94c.36,0,.65-.29,.65-.66,0-.18-.07-.34-.19-.47l-3.36-3.5c-.27-.25-.69-.22-.93,.05-.22,.25-.22,.63,0,.88l2.26,2.36H3.9c-.36,.04-.62,.37-.58,.73,.03,.31,.28,.56,.58,.59Zm12.05,2.23H3.9c-.26,0-.5,.16-.61,.41-.11,.26-.05,.55,.14,.75l3.37,3.49c.25,.26,.66,.26,.92,0,0,0,0,0,0,0,.25-.26,.25-.68,0-.94l-2.28-2.36H15.94c.36,0,.66-.3,.66-.67,0-.37-.29-.67-.66-.67h0Z"
          fill="#5a5b5b"
        />
        <path
          id="path1547"
          d="M2.32,20.02h15.39c1.28,0,2.31-1.04,2.31-2.31V2.32c0-1.28-1.04-2.32-2.31-2.32H2.32C1.04,0,0,1.04,0,2.32v15.39c0,1.28,1.04,2.31,2.32,2.31ZM1.09,2.35c0-.68,.55-1.23,1.23-1.23h15.39c.68,0,1.23,.55,1.23,1.23v15.39c0,.68-.55,1.23-1.23,1.23H2.32c-.68,0-1.23-.55-1.23-1.23h0V2.35Z"
          fill="#5a5b5b"
        />
      </g>
    </svg>
  ),
  Support: (
    <svg
      className="me-3 icon pe-none"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.45 22.75C16.32 22.75 15.13 22.48 13.9 21.96C12.7 21.45 11.49 20.75 10.31 19.9C9.14 19.04 8.01 18.08 6.94 17.03C5.88 15.96 4.92 14.83 4.07 13.67C3.21 12.47 2.52 11.27 2.03 10.11C1.51 8.87 1.25 7.67 1.25 6.54C1.25 5.76 1.39 5.02 1.66 4.33C1.94 3.62 2.39 2.96 3 2.39C3.77 1.63 4.65 1.25 5.59 1.25C5.98 1.25 6.38 1.34 6.72 1.5C7.11 1.68 7.44 1.95 7.68 2.31L10 5.58C10.21 5.87 10.37 6.15 10.48 6.43C10.61 6.73 10.68 7.03 10.68 7.32C10.68 7.7 10.57 8.07 10.36 8.42C10.21 8.69 9.98 8.98 9.69 9.27L9.01 9.98C9.02 10.01 9.03 10.03 9.04 10.05C9.16 10.26 9.4 10.62 9.86 11.16C10.35 11.72 10.81 12.23 11.27 12.7C11.86 13.28 12.35 13.74 12.81 14.12C13.38 14.6 13.75 14.84 13.97 14.95L13.95 15L14.68 14.28C14.99 13.97 15.29 13.74 15.58 13.59C16.13 13.25 16.83 13.19 17.53 13.48C17.79 13.59 18.07 13.74 18.37 13.95L21.69 16.31C22.06 16.56 22.33 16.88 22.49 17.26C22.64 17.64 22.71 17.99 22.71 18.34C22.71 18.82 22.6 19.3 22.39 19.75C22.18 20.2 21.92 20.59 21.59 20.95C21.02 21.58 20.4 22.03 19.68 22.32C18.99 22.6 18.24 22.75 17.45 22.75ZM5.59 2.75C5.04 2.75 4.53 2.99 4.04 3.47C3.58 3.9 3.26 4.37 3.06 4.88C2.85 5.4 2.75 5.95 2.75 6.54C2.75 7.47 2.97 8.48 3.41 9.52C3.86 10.58 4.49 11.68 5.29 12.78C6.09 13.88 7 14.95 8 15.96C9 16.95 10.08 17.87 11.19 18.68C12.27 19.47 13.38 20.11 14.48 20.57C16.19 21.3 17.79 21.47 19.11 20.92C19.62 20.71 20.07 20.39 20.48 19.93C20.71 19.68 20.89 19.41 21.04 19.09C21.16 18.84 21.22 18.58 21.22 18.32C21.22 18.16 21.19 18 21.11 17.82C21.08 17.76 21.02 17.65 20.83 17.52L17.51 15.16C17.31 15.02 17.13 14.92 16.96 14.85C16.74 14.76 16.65 14.67 16.31 14.88C16.11 14.98 15.93 15.13 15.73 15.33L14.97 16.08C14.58 16.46 13.98 16.55 13.52 16.38L13.25 16.26C12.84 16.04 12.36 15.7 11.83 15.25C11.35 14.84 10.83 14.36 10.2 13.74C9.71 13.24 9.22 12.71 8.71 12.12C8.24 11.57 7.9 11.1 7.69 10.71L7.57 10.41C7.51 10.18 7.49 10.05 7.49 9.91C7.49 9.55 7.62 9.23 7.87 8.98L8.62 8.2C8.82 8 8.97 7.81 9.07 7.64C9.15 7.51 9.18 7.4 9.18 7.3C9.18 7.22 9.15 7.1 9.1 6.98C9.03 6.82 8.92 6.64 8.78 6.45L6.46 3.17C6.36 3.03 6.24 2.93 6.09 2.86C5.93 2.79 5.76 2.75 5.59 2.75ZM13.95 15.01L13.79 15.69L14.06 14.99C14.01 14.98 13.97 14.99 13.95 15.01Z"
        fill="#5A5A5A"
      />
    </svg>
  ),
  "Account Manager": (
    <svg
      className="me-3 icon pe-none"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.16055 11.62C9.13055 11.62 9.11055 11.62 9.08055 11.62C9.03055 11.61 8.96055 11.61 8.90055 11.62C6.00055 11.53 3.81055 9.25 3.81055 6.44C3.81055 3.58 6.14055 1.25 9.00055 1.25C11.8605 1.25 14.1905 3.58 14.1905 6.44C14.1805 9.25 11.9805 11.53 9.19055 11.62C9.18055 11.62 9.17055 11.62 9.16055 11.62ZM9.00055 2.75C6.97055 2.75 5.31055 4.41 5.31055 6.44C5.31055 8.44 6.87055 10.05 8.86055 10.12C8.92055 10.11 9.05055 10.11 9.18055 10.12C11.1405 10.03 12.6805 8.42 12.6905 6.44C12.6905 4.41 11.0305 2.75 9.00055 2.75Z"
        fill="#5A5A5A"
      />
      <path
        d="M16.5404 11.75C16.5104 11.75 16.4804 11.75 16.4504 11.74C16.0404 11.78 15.6204 11.49 15.5804 11.08C15.5404 10.67 15.7904 10.3 16.2004 10.25C16.3204 10.24 16.4504 10.24 16.5604 10.24C18.0204 10.16 19.1604 8.96 19.1604 7.49C19.1604 5.97 17.9304 4.74 16.4104 4.74C16.0004 4.75 15.6604 4.41 15.6604 4C15.6604 3.59 16.0004 3.25 16.4104 3.25C18.7504 3.25 20.6604 5.16 20.6604 7.5C20.6604 9.8 18.8604 11.66 16.5704 11.75C16.5604 11.75 16.5504 11.75 16.5404 11.75Z"
        fill="#5A5A5A"
      />
      <path
        d="M9.16961 22.55C7.20961 22.55 5.23961 22.05 3.74961 21.05C2.35961 20.13 1.59961 18.87 1.59961 17.5C1.59961 16.13 2.35961 14.86 3.74961 13.93C6.74961 11.94 11.6096 11.94 14.5896 13.93C15.9696 14.85 16.7396 16.11 16.7396 17.48C16.7396 18.85 15.9796 20.12 14.5896 21.05C13.0896 22.05 11.1296 22.55 9.16961 22.55ZM4.57961 15.19C3.61961 15.83 3.09961 16.65 3.09961 17.51C3.09961 18.36 3.62961 19.18 4.57961 19.81C7.06961 21.48 11.2696 21.48 13.7596 19.81C14.7196 19.17 15.2396 18.35 15.2396 17.49C15.2396 16.64 14.7096 15.82 13.7596 15.19C11.2696 13.53 7.06961 13.53 4.57961 15.19Z"
        fill="#5A5A5A"
      />
      <path
        d="M18.3402 20.75C17.9902 20.75 17.6802 20.51 17.6102 20.15C17.5302 19.74 17.7902 19.35 18.1902 19.26C18.8202 19.13 19.4002 18.88 19.8502 18.53C20.4202 18.1 20.7302 17.56 20.7302 16.99C20.7302 16.42 20.4202 15.88 19.8602 15.46C19.4202 15.12 18.8702 14.88 18.2202 14.73C17.8202 14.64 17.5602 14.24 17.6502 13.83C17.7402 13.43 18.1402 13.17 18.5502 13.26C19.4102 13.45 20.1602 13.79 20.7702 14.26C21.7002 14.96 22.2302 15.95 22.2302 16.99C22.2302 18.03 21.6902 19.02 20.7602 19.73C20.1402 20.21 19.3602 20.56 18.5002 20.73C18.4402 20.75 18.3902 20.75 18.3402 20.75Z"
        fill="#5A5A5A"
      />
    </svg>
  ),
  Settings: (
    <svg
      className="me-3 icon pe-none"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.0002 22.6298C11.3302 22.6298 10.6502 22.4798 10.1202 22.1698L4.62023 18.9998C2.38023 17.4898 2.24023 17.2598 2.24023 14.8898V9.10981C2.24023 6.73981 2.37023 6.5098 4.57023 5.0198L10.1102 1.8198C11.1602 1.2098 12.8102 1.2098 13.8602 1.8198L19.3802 4.9998C21.6202 6.5098 21.7602 6.73981 21.7602 9.10981V14.8798C21.7602 17.2498 21.6302 17.4798 19.4302 18.9698L13.8902 22.1698C13.3502 22.4798 12.6702 22.6298 12.0002 22.6298ZM12.0002 2.8698C11.5802 2.8698 11.1702 2.9498 10.8802 3.1198L5.38023 6.2998C3.75023 7.3998 3.75023 7.39981 3.75023 9.10981V14.8798C3.75023 16.5898 3.75023 16.5898 5.42023 17.7198L10.8802 20.8698C11.4702 21.2098 12.5402 21.2098 13.1302 20.8698L18.6302 17.6898C20.2502 16.5898 20.2502 16.5898 20.2502 14.8798V9.10981C20.2502 7.39981 20.2502 7.39981 18.5802 6.2698L13.1202 3.1198C12.8302 2.9498 12.4202 2.8698 12.0002 2.8698Z"
        fill="#5A5A5A"
      />
      <path
        d="M12 15.75C9.93 15.75 8.25 14.07 8.25 12C8.25 9.93 9.93 8.25 12 8.25C14.07 8.25 15.75 9.93 15.75 12C15.75 14.07 14.07 15.75 12 15.75ZM12 9.75C10.76 9.75 9.75 10.76 9.75 12C9.75 13.24 10.76 14.25 12 14.25C13.24 14.25 14.25 13.24 14.25 12C14.25 10.76 13.24 9.75 12 9.75Z"
        fill="#5A5A5A"
      />
    </svg>
  ),
  "Profile Settings": (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="Layer_2"
      data-name="Layer 2"
      viewBox="0 0 20.58 20.59"
      className="me-3 icon pe-none"
      width="20"
      height="20"
    >
      <g id="SvgjsSvg1029">
        <path
          d="M8.83,0c-2.43,0-4.41,1.98-4.41,4.41s1.98,4.41,4.41,4.41,4.41-1.98,4.41-4.41S11.25,0,8.83,0Zm0,1.47c1.63,0,2.94,1.31,2.94,2.94s-1.31,2.94-2.94,2.94-2.94-1.31-2.94-2.94,1.31-2.94,2.94-2.94Zm-2.21,8.83c-3.65,0-6.62,2.96-6.62,6.62v1.47c0,.41,.33,.74,.74,.74h7.98c.41,0,.74-.33,.74-.74s-.33-.74-.74-.74H1.47v-.74c0-2.86,2.28-5.15,5.15-5.15h2.95c.41,0,.74-.33,.74-.74s-.33-.74-.74-.74h-2.95Zm8.82,0c-.41,0-.73,.34-.73,.74,0,0,0,0,0,0v.8c-.46,.1-.9,.28-1.29,.54l-.56-.56c-.17-.18-.37-.25-.56-.24-.56,.03-1.02,.76-.48,1.28l.57,.57c-.26,.39-.44,.83-.54,1.29h-.8c-.99-.01-.99,1.49,0,1.47h.8c.1,.46,.28,.9,.54,1.28l-.57,.57c-.71,.69,.35,1.75,1.04,1.04l.57-.57c.39,.26,.83,.44,1.29,.54v.8c-.01,.99,1.48,.99,1.47,0v-.8c.46-.1,.9-.28,1.29-.54l.57,.57c.28,.3,.74,.31,1.04,.03,.3-.28,.31-.74,.03-1.04-.01-.01-.02-.02-.03-.03l-.57-.57c.26-.39,.44-.83,.54-1.28h.8c.41,0,.74-.33,.74-.74s-.33-.74-.74-.74h-.8c-.09-.46-.28-.9-.54-1.3l.57-.57c.29-.28,.3-.74,.02-1.04,0,0-.01-.01-.02-.02-.14-.14-.33-.21-.52-.21-.19,0-.38,.08-.51,.22l-.57,.57c-.39-.26-.83-.44-1.29-.54v-.8c0-.41-.32-.74-.72-.75,0,0-.01,0-.02,0h0Zm0,2.94c1.23,0,2.21,.98,2.21,2.21s-.98,2.21-2.21,2.21-2.21-.98-2.21-2.21,.98-2.21,2.21-2.21Z"
          fill="#5a5a5a"
        />
      </g>
    </svg>
  ),
  "Shop Settings": (
    <svg
      className="me-3 icon pe-none"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.0002 22.6298C11.3302 22.6298 10.6502 22.4798 10.1202 22.1698L4.62023 18.9998C2.38023 17.4898 2.24023 17.2598 2.24023 14.8898V9.10981C2.24023 6.73981 2.37023 6.5098 4.57023 5.0198L10.1102 1.8198C11.1602 1.2098 12.8102 1.2098 13.8602 1.8198L19.3802 4.9998C21.6202 6.5098 21.7602 6.73981 21.7602 9.10981V14.8798C21.7602 17.2498 21.6302 17.4798 19.4302 18.9698L13.8902 22.1698C13.3502 22.4798 12.6702 22.6298 12.0002 22.6298ZM12.0002 2.8698C11.5802 2.8698 11.1702 2.9498 10.8802 3.1198L5.38023 6.2998C3.75023 7.3998 3.75023 7.39981 3.75023 9.10981V14.8798C3.75023 16.5898 3.75023 16.5898 5.42023 17.7198L10.8802 20.8698C11.4702 21.2098 12.5402 21.2098 13.1302 20.8698L18.6302 17.6898C20.2502 16.5898 20.2502 16.5898 20.2502 14.8798V9.10981C20.2502 7.39981 20.2502 7.39981 18.5802 6.2698L13.1202 3.1198C12.8302 2.9498 12.4202 2.8698 12.0002 2.8698Z"
        fill="#5A5A5A"
      />
      <path
        d="M12 15.75C9.93 15.75 8.25 14.07 8.25 12C8.25 9.93 9.93 8.25 12 8.25C14.07 8.25 15.75 9.93 15.75 12C15.75 14.07 14.07 15.75 12 15.75ZM12 9.75C10.76 9.75 9.75 10.76 9.75 12C9.75 13.24 10.76 14.25 12 14.25C13.24 14.25 14.25 13.24 14.25 12C14.25 10.76 13.24 9.75 12 9.75Z"
        fill="#5A5A5A"
      />
    </svg>
  ),
  News: (
    <svg
      className="me-3 icon pe-none"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 22.75H9C3.57 22.75 1.25 20.43 1.25 15V9C1.25 3.57 3.57 1.25 9 1.25H15C20.43 1.25 22.75 3.57 22.75 9V15C22.75 20.43 20.43 22.75 15 22.75ZM9 2.75C4.39 2.75 2.75 4.39 2.75 9V15C2.75 19.61 4.39 21.25 9 21.25H15C19.61 21.25 21.25 19.61 21.25 15V9C21.25 4.39 19.61 2.75 15 2.75H9Z"
        fill="#5A5A5A"
      />
      <path
        d="M15.75 9.75H8.25C7.84 9.75 7.5 9.41 7.5 9C7.5 8.59 7.84 8.25 8.25 8.25H15.75C16.16 8.25 16.5 8.59 16.5 9C16.5 9.41 16.16 9.75 15.75 9.75Z"
        fill="#5A5A5A"
      />
      <path
        d="M15.75 15.75H8.25C7.84 15.75 7.5 15.41 7.5 15C7.5 14.59 7.84 14.25 8.25 14.25H15.75C16.16 14.25 16.5 14.59 16.5 15C16.5 15.41 16.16 15.75 15.75 15.75Z"
        fill="#5A5A5A"
      />
    </svg>
  ),
  Blogs: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="me-3 icon pe-none"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      id="blog"
    >
      <g data-name="blog blogger blogspot post web">
        <path
          d="M26 12h-2V8a5 5 0 0 0-5-5H8a5 5 0 0 0-5 5v12a1 1 0 0 0 2 0V8a3 3 0 0 1 3-3h11a3 3 0 0 1 3 3v5a1 1 0 0 0 1 1h3a1 1 0 0 1 1 1v9a3 3 0 0 1-3 3H8a3 3 0 0 1-3-3 1 1 0 0 0-2 0 5 5 0 0 0 5 5h16a5 5 0 0 0 5-5v-9a3 3 0 0 0-3-3Z"
          fill="#5A5A5A"
        ></path>
        <path
          d="M11.5 14h4a2.5 2.5 0 0 0 0-5h-4a2.5 2.5 0 0 0 0 5zm0-3h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1 0-1zm0 12h9a2.5 2.5 0 0 0 0-5h-9a2.5 2.5 0 0 0 0 5zm0-3h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1 0-1z"
          fill="#5A5A5A"
        ></path>
      </g>
    </svg>
  ),
  Sellers: (
    <svg
      className="me-3 icon pe-none"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.0002 22.7498H8.00023C3.38023 22.7498 2.52023 20.5998 2.30023 18.5098L1.55023 10.4998C1.44023 9.44977 1.41023 7.89977 2.45023 6.73977C3.35023 5.73977 4.84023 5.25977 7.00023 5.25977H17.0002C19.1702 5.25977 20.6602 5.74977 21.5502 6.73977C22.5902 7.89977 22.5602 9.44977 22.4502 10.5098L21.7002 18.4998C21.4802 20.5998 20.6202 22.7498 16.0002 22.7498ZM7.00023 6.74977C5.31023 6.74977 4.15023 7.07977 3.56023 7.73977C3.07023 8.27977 2.91023 9.10977 3.04023 10.3498L3.79023 18.3598C3.96023 19.9398 4.39023 21.2498 8.00023 21.2498H16.0002C19.6002 21.2498 20.0402 19.9398 20.2102 18.3498L20.9602 10.3598C21.0902 9.10977 20.9302 8.27977 20.4402 7.73977C19.8502 7.07977 18.6902 6.74977 17.0002 6.74977H7.00023Z"
        fill="#5A5A5A"
      />
      <path
        d="M16 6.75C15.59 6.75 15.25 6.41 15.25 6V5.2C15.25 3.42 15.25 2.75 12.8 2.75H11.2C8.75 2.75 8.75 3.42 8.75 5.2V6C8.75 6.41 8.41 6.75 8 6.75C7.59 6.75 7.25 6.41 7.25 6V5.2C7.25 3.44 7.25 1.25 11.2 1.25H12.8C16.75 1.25 16.75 3.44 16.75 5.2V6C16.75 6.41 16.41 6.75 16 6.75Z"
        fill="#5A5A5A"
      />
      <path
        d="M12 16.75C9.25 16.75 9.25 15.05 9.25 14.03V13C9.25 11.59 9.59 11.25 11 11.25H13C14.41 11.25 14.75 11.59 14.75 13V14C14.75 15.04 14.75 16.75 12 16.75ZM10.75 12.75C10.75 12.83 10.75 12.92 10.75 13V14.03C10.75 15.06 10.75 15.25 12 15.25C13.25 15.25 13.25 15.09 13.25 14.02V13C13.25 12.92 13.25 12.83 13.25 12.75C13.17 12.75 13.08 12.75 13 12.75H11C10.92 12.75 10.83 12.75 10.75 12.75Z"
        fill="#5A5A5A"
      />
      <path
        d="M13.9995 14.7702C13.6295 14.7702 13.2995 14.4902 13.2595 14.1102C13.2095 13.7002 13.4995 13.3202 13.9095 13.2702C16.5495 12.9402 19.0795 11.9402 21.2095 10.3902C21.5395 10.1402 22.0095 10.2202 22.2595 10.5602C22.4995 10.8902 22.4295 11.3602 22.0895 11.6102C19.7495 13.3102 16.9895 14.4002 14.0895 14.7702C14.0595 14.7702 14.0295 14.7702 13.9995 14.7702Z"
        fill="#5A5A5A"
      />
      <path
        d="M10.0007 14.7799C9.97072 14.7799 9.94072 14.7799 9.91072 14.7799C7.17072 14.4699 4.50072 13.4699 2.19072 11.8899C1.85072 11.6599 1.76072 11.1899 1.99072 10.8499C2.22072 10.5099 2.69072 10.4199 3.03072 10.6499C5.14072 12.0899 7.57072 12.9999 10.0707 13.2899C10.4807 13.3399 10.7807 13.7099 10.7307 14.1199C10.7007 14.4999 10.3807 14.7799 10.0007 14.7799Z"
        fill="#5A5A5A"
      />
    </svg>
  ),
  Users: (
    <svg
      className="me-3 icon pe-none"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.16055 11.62C9.13055 11.62 9.11055 11.62 9.08055 11.62C9.03055 11.61 8.96055 11.61 8.90055 11.62C6.00055 11.53 3.81055 9.25 3.81055 6.44C3.81055 3.58 6.14055 1.25 9.00055 1.25C11.8605 1.25 14.1905 3.58 14.1905 6.44C14.1805 9.25 11.9805 11.53 9.19055 11.62C9.18055 11.62 9.17055 11.62 9.16055 11.62ZM9.00055 2.75C6.97055 2.75 5.31055 4.41 5.31055 6.44C5.31055 8.44 6.87055 10.05 8.86055 10.12C8.92055 10.11 9.05055 10.11 9.18055 10.12C11.1405 10.03 12.6805 8.42 12.6905 6.44C12.6905 4.41 11.0305 2.75 9.00055 2.75Z"
        fill="#5A5A5A"
      />
      <path
        d="M16.5404 11.75C16.5104 11.75 16.4804 11.75 16.4504 11.74C16.0404 11.78 15.6204 11.49 15.5804 11.08C15.5404 10.67 15.7904 10.3 16.2004 10.25C16.3204 10.24 16.4504 10.24 16.5604 10.24C18.0204 10.16 19.1604 8.96 19.1604 7.49C19.1604 5.97 17.9304 4.74 16.4104 4.74C16.0004 4.75 15.6604 4.41 15.6604 4C15.6604 3.59 16.0004 3.25 16.4104 3.25C18.7504 3.25 20.6604 5.16 20.6604 7.5C20.6604 9.8 18.8604 11.66 16.5704 11.75C16.5604 11.75 16.5504 11.75 16.5404 11.75Z"
        fill="#5A5A5A"
      />
      <path
        d="M9.16961 22.55C7.20961 22.55 5.23961 22.05 3.74961 21.05C2.35961 20.13 1.59961 18.87 1.59961 17.5C1.59961 16.13 2.35961 14.86 3.74961 13.93C6.74961 11.94 11.6096 11.94 14.5896 13.93C15.9696 14.85 16.7396 16.11 16.7396 17.48C16.7396 18.85 15.9796 20.12 14.5896 21.05C13.0896 22.05 11.1296 22.55 9.16961 22.55ZM4.57961 15.19C3.61961 15.83 3.09961 16.65 3.09961 17.51C3.09961 18.36 3.62961 19.18 4.57961 19.81C7.06961 21.48 11.2696 21.48 13.7596 19.81C14.7196 19.17 15.2396 18.35 15.2396 17.49C15.2396 16.64 14.7096 15.82 13.7596 15.19C11.2696 13.53 7.06961 13.53 4.57961 15.19Z"
        fill="#5A5A5A"
      />
      <path
        d="M18.3402 20.75C17.9902 20.75 17.6802 20.51 17.6102 20.15C17.5302 19.74 17.7902 19.35 18.1902 19.26C18.8202 19.13 19.4002 18.88 19.8502 18.53C20.4202 18.1 20.7302 17.56 20.7302 16.99C20.7302 16.42 20.4202 15.88 19.8602 15.46C19.4202 15.12 18.8702 14.88 18.2202 14.73C17.8202 14.64 17.5602 14.24 17.6502 13.83C17.7402 13.43 18.1402 13.17 18.5502 13.26C19.4102 13.45 20.1602 13.79 20.7702 14.26C21.7002 14.96 22.2302 15.95 22.2302 16.99C22.2302 18.03 21.6902 19.02 20.7602 19.73C20.1402 20.21 19.3602 20.56 18.5002 20.73C18.4402 20.75 18.3902 20.75 18.3402 20.75Z"
        fill="#5A5A5A"
      />
    </svg>
  ),
  Documents: (
    <svg
      className="me-3 icon pe-none"
      width="24"
      height="24"
      viewBox="1 3 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9,10h1a1,1,0,0,0,0-2H9a1,1,0,0,0,0,2Zm0,2a1,1,0,0,0,0,2h6a1,1,0,0,0,0-2ZM20,8.94a1.31,1.31,0,0,0-.06-.27l0-.09a1.07,1.07,0,0,0-.19-.28h0l-6-6h0a1.07,1.07,0,0,0-.28-.19.32.32,0,0,0-.09,0A.88.88,0,0,0,13.05,2H7A3,3,0,0,0,4,5V19a3,3,0,0,0,3,3H17a3,3,0,0,0,3-3V9S20,9,20,8.94ZM14,5.41,16.59,8H15a1,1,0,0,1-1-1ZM18,19a1,1,0,0,1-1,1H7a1,1,0,0,1-1-1V5A1,1,0,0,1,7,4h5V7a3,3,0,0,0,3,3h3Zm-3-3H9a1,1,0,0,0,0,2h6a1,1,0,0,0,0-2Z"
        fill="#5A5A5A"
      ></path>
    </svg>
  ),
  "Element Styles": (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      id="drawing"
      class="me-3 icon pe-none"
      width="24"
      height="24"
    >
      <path
        fill="none"
        stroke="#5A5A5A"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="3"
        d="M46.37 13.13H7.29a2.56 2.56 0 0 0-2.56 2.56v32.62a2.56 2.56 0 0 0 2.56 2.56h49.42a2.56 2.56 0 0 0 2.56-2.56V15.68a2.55 2.55 0 0 0-2.56-2.55h0"
      ></path>
      <path
        fill="none"
        stroke="#5A5A5A"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="3"
        d="m46.59 27.22-4.43 1.55A1.83 1.83 0 0 1 39.72 27l.05-4.69L50 8.06a4.2 4.2 0 0 1 5.86-1h0a4.19 4.19 0 0 1 1 5.85ZM5.36 49.99l15.03-21.11L34.5 50.87l12.88-12.99 11.16 12.21"
      ></path>
      <circle
        cx="30.95"
        cy="23.11"
        r="4.5"
        fill="none"
        stroke="#5A5A5A"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="3"
      ></circle>
      <path
        fill="none"
        stroke="#5A5A5A"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="3"
        d="m41.59 19.79 6.68 5.08"
      ></path>
    </svg>
  ),
  "Home Banners": (
    <svg
      className="me-3 icon pe-none"
      width="20"
      height="20"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      id="sign-banner"
    >
      <path
        d="M29,2H3A1,1,0,0,0,2,3V19a1,1,0,0,0,1,1H6v9a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V20h8v9a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V20h3a1,1,0,0,0,1-1V3A1,1,0,0,0,29,2ZM10,28H8V20h2Zm14,0H22V20h2Zm4-10H4V4H28Z"
        fill="#5A5A5A"
      ></path>
    </svg>
  ),
  "Product Categories": (
    <svg
      className="me-3 icon pe-none"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.19 17.75H7.53999C6.54999 17.75 5.59999 17.33 4.92999 16.6C4.25999 15.87 3.92 14.89 4 13.9L4.83 3.94C4.86 3.63 4.74999 3.33001 4.53999 3.10001C4.32999 2.87001 4.04 2.75 3.73 2.75H2C1.59 2.75 1.25 2.41 1.25 2C1.25 1.59 1.59 1.25 2 1.25H3.74001C4.47001 1.25 5.15999 1.56 5.64999 2.09C5.91999 2.39 6.12 2.74 6.23 3.13H18.72C19.73 3.13 20.66 3.53 21.34 4.25C22.01 4.98 22.35 5.93 22.27 6.94L21.73 14.44C21.62 16.27 20.02 17.75 18.19 17.75ZM6.28 4.62L5.5 14.02C5.45 14.6 5.64 15.15 6.03 15.58C6.42 16.01 6.95999 16.24 7.53999 16.24H18.19C19.23 16.24 20.17 15.36 20.25 14.32L20.79 6.82001C20.83 6.23001 20.64 5.67001 20.25 5.26001C19.86 4.84001 19.32 4.60999 18.73 4.60999H6.28V4.62Z"
        fill="#5A5A5A"
      />
      <path
        d="M16.25 22.75C15.15 22.75 14.25 21.85 14.25 20.75C14.25 19.65 15.15 18.75 16.25 18.75C17.35 18.75 18.25 19.65 18.25 20.75C18.25 21.85 17.35 22.75 16.25 22.75ZM16.25 20.25C15.97 20.25 15.75 20.47 15.75 20.75C15.75 21.03 15.97 21.25 16.25 21.25C16.53 21.25 16.75 21.03 16.75 20.75C16.75 20.47 16.53 20.25 16.25 20.25Z"
        fill="#5A5A5A"
      />
      <path
        d="M8.25 22.75C7.15 22.75 6.25 21.85 6.25 20.75C6.25 19.65 7.15 18.75 8.25 18.75C9.35 18.75 10.25 19.65 10.25 20.75C10.25 21.85 9.35 22.75 8.25 22.75ZM8.25 20.25C7.97 20.25 7.75 20.47 7.75 20.75C7.75 21.03 7.97 21.25 8.25 21.25C8.53 21.25 8.75 21.03 8.75 20.75C8.75 20.47 8.53 20.25 8.25 20.25Z"
        fill="#5A5A5A"
      />
      <path
        d="M21 8.75H9C8.59 8.75 8.25 8.41 8.25 8C8.25 7.59 8.59 7.25 9 7.25H21C21.41 7.25 21.75 7.59 21.75 8C21.75 8.41 21.41 8.75 21 8.75Z"
        fill="#5A5A5A"
      />
    </svg>
  ),
  "Service Categories": (
    <svg
      className="me-3 icon pe-none"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 10.75H5C2.58 10.75 1.25 9.42 1.25 7V5C1.25 2.58 2.58 1.25 5 1.25H7C9.42 1.25 10.75 2.58 10.75 5V7C10.75 9.42 9.42 10.75 7 10.75ZM5 2.75C3.42 2.75 2.75 3.42 2.75 5V7C2.75 8.58 3.42 9.25 5 9.25H7C8.58 9.25 9.25 8.58 9.25 7V5C9.25 3.42 8.58 2.75 7 2.75H5Z"
        fill="#5A5A5A"
      />
      <path
        d="M19 10.75H17C14.58 10.75 13.25 9.42 13.25 7V5C13.25 2.58 14.58 1.25 17 1.25H19C21.42 1.25 22.75 2.58 22.75 5V7C22.75 9.42 21.42 10.75 19 10.75ZM17 2.75C15.42 2.75 14.75 3.42 14.75 5V7C14.75 8.58 15.42 9.25 17 9.25H19C20.58 9.25 21.25 8.58 21.25 7V5C21.25 3.42 20.58 2.75 19 2.75H17Z"
        fill="#5A5A5A"
      />
      <path
        d="M19 22.75H17C14.58 22.75 13.25 21.42 13.25 19V17C13.25 14.58 14.58 13.25 17 13.25H19C21.42 13.25 22.75 14.58 22.75 17V19C22.75 21.42 21.42 22.75 19 22.75ZM17 14.75C15.42 14.75 14.75 15.42 14.75 17V19C14.75 20.58 15.42 21.25 17 21.25H19C20.58 21.25 21.25 20.58 21.25 19V17C21.25 15.42 20.58 14.75 19 14.75H17Z"
        fill="#5A5A5A"
      />
      <path
        d="M7 22.75H5C2.58 22.75 1.25 21.42 1.25 19V17C1.25 14.58 2.58 13.25 5 13.25H7C9.42 13.25 10.75 14.58 10.75 17V19C10.75 21.42 9.42 22.75 7 22.75ZM5 14.75C3.42 14.75 2.75 15.42 2.75 17V19C2.75 20.58 3.42 21.25 5 21.25H7C8.58 21.25 9.25 20.58 9.25 19V17C9.25 15.42 8.58 14.75 7 14.75H5Z"
        fill="#5A5A5A"
      />
    </svg>
  ),
  Reports: (
    <svg
      className="me-3 icon pe-none"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.4 22.75H7.6C3.21 22.75 1.25 20.79 1.25 16.4V12.6C1.25 8.21 3.21 6.25 7.6 6.25H10.6C11.01 6.25 11.35 6.59 11.35 7C11.35 7.41 11.01 7.75 10.6 7.75H7.6C4.02 7.75 2.75 9.02 2.75 12.6V16.4C2.75 19.98 4.02 21.25 7.6 21.25H11.4C14.98 21.25 16.25 19.98 16.25 16.4V13.4C16.25 12.99 16.59 12.65 17 12.65C17.41 12.65 17.75 12.99 17.75 13.4V16.4C17.75 20.79 15.79 22.75 11.4 22.75Z"
        fill="#5A5A5A"
      />
      <path
        d="M16.9996 14.1505H13.7996C10.9896 14.1505 9.84961 13.0105 9.84961 10.2005V7.00048C9.84961 6.70048 10.0296 6.42048 10.3096 6.31048C10.5896 6.19048 10.9096 6.26048 11.1296 6.47048L17.5296 12.8705C17.7396 13.0805 17.8096 13.4105 17.6896 13.6905C17.5796 13.9705 17.2996 14.1505 16.9996 14.1505ZM11.3496 8.81048V10.2005C11.3496 12.1905 11.8096 12.6505 13.7996 12.6505H15.1896L11.3496 8.81048Z"
        fill="#5A5A5A"
      />
      <path
        d="M15.5996 2.75H11.5996C11.1896 2.75 10.8496 2.41 10.8496 2C10.8496 1.59 11.1896 1.25 11.5996 1.25H15.5996C16.0096 1.25 16.3496 1.59 16.3496 2C16.3496 2.41 16.0096 2.75 15.5996 2.75Z"
        fill="#5A5A5A"
      />
      <path
        d="M7 5.75C6.59 5.75 6.25 5.41 6.25 5C6.25 2.93 7.93 1.25 10 1.25H12.62C13.03 1.25 13.37 1.59 13.37 2C13.37 2.41 13.03 2.75 12.62 2.75H10C8.76 2.75 7.75 3.76 7.75 5C7.75 5.41 7.41 5.75 7 5.75Z"
        fill="#5A5A5A"
      />
      <path
        d="M19.1895 17.75C18.7795 17.75 18.4395 17.41 18.4395 17C18.4395 16.59 18.7795 16.25 19.1895 16.25C20.3295 16.25 21.2495 15.32 21.2495 14.19V8C21.2495 7.59 21.5895 7.25 21.9995 7.25C22.4095 7.25 22.7495 7.59 22.7495 8V14.19C22.7495 16.15 21.1495 17.75 19.1895 17.75Z"
        fill="#5A5A5A"
      />
      <path
        d="M22 8.75048H19C16.34 8.75048 15.25 7.66048 15.25 5.00048V2.00048C15.25 1.70048 15.43 1.42048 15.71 1.31048C15.99 1.19048 16.31 1.26048 16.53 1.47048L22.53 7.47048C22.74 7.68048 22.81 8.01048 22.69 8.29048C22.58 8.57048 22.3 8.75048 22 8.75048ZM16.75 3.81048V5.00048C16.75 6.83048 17.17 7.25048 19 7.25048H20.19L16.75 3.81048Z"
        fill="#5A5A5A"
      />
    </svg>
  ),
  Pets: (
    <svg
      className="me-3 icon pe-none"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.0392 22.75H9.24923C7.62923 22.75 6.15923 22.12 5.09923 20.96C4.03923 19.81 3.52923 18.29 3.66923 16.68C4.00923 12.58 7.62923 9.25 11.7492 9.25C15.5392 9.25 19.1192 12.29 19.7492 16.02C20.0492 17.8 19.6092 19.48 18.5292 20.76C17.4292 22.04 15.8392 22.75 14.0392 22.75ZM11.7392 10.75C8.38923 10.75 5.43923 13.47 5.15923 16.81C5.05923 18 5.42923 19.11 6.19923 19.95C6.96923 20.79 8.04923 21.25 9.23923 21.25H14.0292C15.3792 21.25 16.5692 20.73 17.3592 19.8C18.1492 18.87 18.4692 17.61 18.2492 16.27C17.7492 13.23 14.8292 10.75 11.7392 10.75Z"
        fill="#5A5A5A"
      />
      <path
        d="M10.4707 8.25C8.6807 8.25 7.2207 6.79 7.2207 5C7.2207 3.21 8.6807 1.75 10.4707 1.75C12.2607 1.75 13.7207 3.21 13.7207 5C13.7207 6.79 12.2707 8.25 10.4707 8.25ZM10.4707 3.25C9.5107 3.25 8.7207 4.04 8.7207 5C8.7207 5.96 9.5107 6.75 10.4707 6.75C11.4307 6.75 12.2207 5.96 12.2207 5C12.2207 4.04 11.4407 3.25 10.4707 3.25Z"
        fill="#5A5A5A"
      />
      <path
        d="M17.3008 9.4502C15.7808 9.4502 14.5508 8.2202 14.5508 6.7002C14.5508 5.1802 15.7808 3.9502 17.3008 3.9502C18.8208 3.9502 20.0508 5.1802 20.0508 6.7002C20.0508 8.2202 18.8208 9.4502 17.3008 9.4502ZM17.3008 5.4502C16.6108 5.4502 16.0508 6.0102 16.0508 6.7002C16.0508 7.3902 16.6108 7.9502 17.3008 7.9502C17.9908 7.9502 18.5508 7.3902 18.5508 6.7002C18.5508 6.0102 17.9908 5.4502 17.3008 5.4502Z"
        fill="#5A5A5A"
      />
      <path
        d="M21 13.4502C19.76 13.4502 18.75 12.4402 18.75 11.2002C18.75 9.96019 19.76 8.9502 21 8.9502C22.24 8.9502 23.25 9.96019 23.25 11.2002C23.25 12.4402 22.24 13.4502 21 13.4502ZM21 10.4502C20.59 10.4502 20.25 10.7902 20.25 11.2002C20.25 11.6102 20.59 11.9502 21 11.9502C21.41 11.9502 21.75 11.6102 21.75 11.2002C21.75 10.7902 21.41 10.4502 21 10.4502Z"
        fill="#5A5A5A"
      />
      <path
        d="M3.9707 11.4502C2.4507 11.4502 1.2207 10.2202 1.2207 8.7002C1.2207 7.1802 2.4507 5.9502 3.9707 5.9502C5.4907 5.9502 6.7207 7.1802 6.7207 8.7002C6.7207 10.2202 5.4907 11.4502 3.9707 11.4502ZM3.9707 7.4502C3.2807 7.4502 2.7207 8.0102 2.7207 8.7002C2.7207 9.3902 3.2807 9.9502 3.9707 9.9502C4.6607 9.9502 5.2207 9.3902 5.2207 8.7002C5.2207 8.0102 4.6607 7.4502 3.9707 7.4502Z"
        fill="#5A5A5A"
      />
    </svg>
  ),
  Shelter: (
    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      className="me-3 icon pe-none"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <path
        d="M21.86,8.55L11.4,.38c-.14-.11-.33-.11-.47,0L.45,8.54c-.09,.07-.15,.19-.15,.31v4.31c0,.15,.08,.28,.21,.35,.13,.06,.28,.05,.39-.04l1.74-1.37v9.52c0,.21,.19,.38,.4,.38H19.07c.21,0,.39-.17,.4-.38V11.95l1.93,1.51c.07,.05,.15,.08,.23,.08,.06,0,.11-.01,.16-.04,.13-.07,.21-.2,.21-.35v-4.31c0-.12-.05-.23-.15-.31ZM3.41,21.23V11.51l7.75-6.02,7.54,5.87v9.87H3.41ZM21.24,12.38L11.4,4.69c-.14-.11-.33-.11-.46,0L1.06,12.38v-3.34L11.16,1.17l10.07,7.87v3.34Z"
        fill="#5a5b5b"
        stroke="#5a5b5c"
        strokeMiterlimit="10"
        strokeWidth=".6"
      />
      <path
        d="M15.46,12.93c-.27-1.34-1.24-2.21-2.47-2.21-.59,0-1.22,.21-1.84,.61-.63-.42-1.25-.63-1.86-.63-1.24,0-2.2,.88-2.46,2.23-.36,1.89,.76,4.39,4.07,5.72,0,0,.01,0,.02,0,.07,.02,.15,.04,.22,.04,.08,0,.15-.01,.22-.04,0,0,.02,0,.02,0,3.31-1.35,4.43-3.85,4.07-5.72h0Zm-4.31,4.98c-2.87-1.17-3.86-3.27-3.56-4.84,.19-.99,.84-1.61,1.71-1.61,.51,0,1.07,.22,1.63,.64,.13,.1,.32,.1,.45,0,.56-.41,1.12-.62,1.62-.62,.86,0,1.52,.61,1.72,1.59,.41,2.15-1.49,3.97-3.56,4.84Z"
        fill="#5a5b5c"
        stroke="#5a5b5c"
        strokeMiterlimit="10"
        strokeWidth=".6"
      />
    </svg>
  ),
  Clinic: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="SvgjsSvg1011"
      viewBox="0 0 18.98 24"
      className="me-3 icon pe-none"
      width="24"
      height="24"
    >
      <path
        d="M9.49,0C6.45,0,3.94,2.24,3.52,5.14h-.93c-1.42,0-2.59,1.16-2.59,2.57v13.71c0,1.41,1.17,2.57,2.59,2.57,4.61,0,9.2,0,13.8,0,1.42,0,2.59-1.16,2.59-2.57V7.71c0-1.41-1.17-2.57-2.59-2.57h-.93c-.42-2.9-2.94-5.14-5.98-5.14Zm0,1.71c2.36,0,4.26,1.85,4.31,4.18,0,.07,0,.15,0,.22-.06,2.32-1.96,4.18-4.31,4.18s-4.25-1.86-4.31-4.18c.01-.07,.01-.15,0-.22,.06-2.32,1.95-4.17,4.31-4.17h0Zm-.01,1.7c-.47,0-.85,.4-.85,.87v.86h-.86s-.06,0-.09,0c-1.12,.08-1.04,1.75,.09,1.71h.86v.85c-.03,1.17,1.75,1.17,1.73,0v-.85h.86c1.13-.02,1.13-1.69,0-1.71h-.86v-.86c0-.48-.39-.88-.88-.87h0ZM2.59,6.86h.93c.42,2.9,2.94,5.15,5.97,5.15s5.55-2.25,5.98-5.15h.93c.49,0,.86,.37,.86,.86v13.71c0,.49-.37,.86-.86,.86h-3.45v-4.28c0-.47-.38-.86-.86-.86H6.9c-.48,0-.86,.39-.86,.86v4.28H2.59c-.49,0-.86-.37-.86-.86V7.71c0-.49,.37-.86,.86-.86h0Zm.86,6c-1.18-.03-1.18,1.74,0,1.71h1.73c1.13-.02,1.13-1.69,0-1.71h-1.73Zm5.18,0c-1.18-.03-1.18,1.74,0,1.71h1.73c1.13-.02,1.13-1.69,0-1.71h-1.73Zm5.18,0c-1.18-.03-1.18,1.74,0,1.71h1.73c1.13-.02,1.13-1.69,0-1.71h-1.73Zm-6.04,6h3.44v3.43h-3.44v-3.43Z"
        fill="#5a5b5c"
      />
    </svg>
  ),
  "Adoption Orders": (
    <svg
      className="me-3 icon pe-none"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 22.75H8C4.35 22.75 2.25 20.65 2.25 17V7C2.25 3.35 4.35 1.25 8 1.25H16C19.65 1.25 21.75 3.35 21.75 7V17C21.75 20.65 19.65 22.75 16 22.75ZM8 2.75C5.14 2.75 3.75 4.14 3.75 7V17C3.75 19.86 5.14 21.25 8 21.25H16C18.86 21.25 20.25 19.86 20.25 17V7C20.25 4.14 18.86 2.75 16 2.75H8Z"
        fill="#5A5A5A"
      />
      <path
        d="M18.5 9.25H16.5C14.98 9.25 13.75 8.02 13.75 6.5V4.5C13.75 4.09 14.09 3.75 14.5 3.75C14.91 3.75 15.25 4.09 15.25 4.5V6.5C15.25 7.19 15.81 7.75 16.5 7.75H18.5C18.91 7.75 19.25 8.09 19.25 8.5C19.25 8.91 18.91 9.25 18.5 9.25Z"
        fill="#5A5A5A"
      />
      <path
        d="M12 13.75H8C7.59 13.75 7.25 13.41 7.25 13C7.25 12.59 7.59 12.25 8 12.25H12C12.41 12.25 12.75 12.59 12.75 13C12.75 13.41 12.41 13.75 12 13.75Z"
        fill="#5A5A5A"
      />
      <path
        d="M16 17.75H8C7.59 17.75 7.25 17.41 7.25 17C7.25 16.59 7.59 16.25 8 16.25H16C16.41 16.25 16.75 16.59 16.75 17C16.75 17.41 16.41 17.75 16 17.75Z"
        fill="#5A5A5A"
      />
    </svg>
  ),
  Shop: (
    <svg
      id="SvgjsSvg1020"
      xmlns="http://www.w3.org/2000/svg"
      className="me-3 icon pe-none"
      width="23"
      height="23"
      viewBox="0 0 24 24"
    >
      <path
        d="M23.82,7.99l-.04-.14s-.04-.04-.04-.07L21.18,.56c-.11-.35-.42-.56-.81-.56H3.7c-.35,0-.67,.21-.81,.56L.28,7.74s-.04,.07-.04,.14l-.11,.25c-.04,.07-.04,.14-.04,.21-.07,.32-.11,.6-.11,.84,0,1.55,.99,2.89,2.39,3.41v10.56c0,.46,.39,.84,.84,.84H21.11c.46,0,.84-.39,.84-.84V12.46c1.2-.6,2.04-1.83,2.04-3.27,0-.25-.04-.53-.11-.81,.04-.14,0-.25-.07-.39Zm-3.52,14.32H4.12V12.81s.11-.04,.14-.04c.88-.14,1.65-.6,2.22-1.27,.67,.81,1.65,1.3,2.78,1.3s2.11-.49,2.78-1.3c.67,.81,1.65,1.3,2.78,1.3s2.11-.49,2.78-1.3c.49,.56,1.13,.99,1.87,1.2h.04c.07,.04,.18,.04,.25,.04,.04,0,.11,.04,.14,.04,.07,0,.14,0,.21,.04h.14v9.5h.07Zm.63-11.26c-.11,.04-.18,.04-.25,.07-.11,0-.18,.04-.28,.04-.14,0-.25,0-.39-.04-.11-.04-.21-.04-.28-.11h-.04c-.67-.28-1.16-.91-1.2-1.65v-.14c0-.46-.39-.84-.84-.84s-.88,.35-.88,.81v.18c-.07,.74-.56,1.37-1.2,1.65h-.04l-.32,.11h-.42c-.14,0-.25,0-.39-.04-.11-.04-.21-.04-.28-.11h-.04c-.67-.28-1.16-.91-1.2-1.65v-.14c0-.46-.39-.84-.84-.84s-.84,.39-.84,.84v.18c-.07,.74-.56,1.37-1.2,1.65h-.04l-.32,.11h-.42c-.11,0-.25,0-.39-.04-.11-.04-.21-.04-.32-.11h-.04c-.67-.28-1.16-.91-1.2-1.65v-.14c0-.46-.39-.84-.84-.84s-.84,.39-.84,.84v.18c-.07,.74-.56,1.37-1.2,1.65h-.04c-.11,.04-.21,.07-.28,.11h-.46c-.07,0-.14,0-.21-.04h-.11c-.91-.18-1.62-.95-1.62-1.9,0-.14,.04-.32,.11-.53,0-.04,0-.07,.04-.07L4.33,1.72h15.48l2.39,6.69s0,.04,.04,.07l.04,.14s0,.07,.04,.07c.07,.21,.11,.39,.11,.53-.07,.84-.67,1.58-1.48,1.83Z"
        fill="#5a5b5b"
      />
      <path
        d="M9.6,22.31v-4.75c0-.48,.39-.87,.87-.87h3.19c.48,0,.87,.39,.87,.87v4.75"
        fill="none"
        stroke="#5a5b5b"
        strokeMiterlimit="10"
        strokeWidth="1.5"
      />
    </svg>
  ),
};
const getIconForTitle = (title) => {
  if (icons[title] !== undefined) {
    return icons[title];
  }

  // default to this icon
  return icons["Dashboard"];
};

const DashboardSideBar = () => {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [menus, setMenus] = useState([]);

  useEffect(() => {
    let menusItems = JSON.parse(localStorage.getItem("user_menus"));
    const currentPath = window.location.pathname;
    setMenus(menusItems);
    let possibleSelectedIndex = 0;
    let foundExactMatchLink = false;
    for (let i = 0; i < menusItems.length; i++) {
      if (menusItems[i].link === currentPath) {
        setSelectedIndex(i);
        foundExactMatchLink = true;
        break;
      } else if (currentPath.includes(menusItems[i].link)) {
        possibleSelectedIndex = i;
      }
    }

    const updatedMenus = menusItems.filter((menu) => {
      if (
        menu.title === "Settings" &&
        menu.submenu &&
        localStorage.getItem("user_role") === "super-admin"
      ) {
        return false;
      }
      return true;
    });

    setMenus(updatedMenus);

    if (!foundExactMatchLink && possibleSelectedIndex > 0) {
      setSelectedIndex(possibleSelectedIndex);
    }
  }, []);

  let renderedRoleMenus = {};
  const closeSideBar = () => {
    const sidebar = document.getElementById("dashboard-sidebar");
    sidebar.classList.toggle("open");
  };
  return (
    <div id="dashboard-sidebar" className={"bg-white dashboard-sidebar"}>
      <div
        className={
          "d-flex justify-content-end mobile-only menu-close-container"
        }
      >
        <span onClick={closeSideBar}>{circleXIcon}</span>
      </div>
      <div className="dashboard-logo p-4 d-flex justify-content-center">
        <img src={logoBlack} alt="logoBlack" />
      </div>
      <ul className="no-print bg-white px-4 flex-1 pt-3">
        {menus.map((menu, index) => {
          if (menu.role && renderedRoleMenus[menu.role] === undefined) {
            renderedRoleMenus[menu.role] = true;
          } else if (menu.role) {
            return <div key={index}></div>;
          }
          if (menu.submenu) {
            return (
              <div key={index}>
                <li
                  className="list-item d-flex align-items-center py-sm-3 py-2 px-4 pe-5 collapsed position-relative submenu-item"
                  data-bs-toggle="collapse"
                  data-bs-target={`#details-collapse`}
                >
                  {getIconForTitle(menu.title)}
                  <p className="m-0 fw-bold pe-none submenu-role">
                    {menu.title}
                  </p>
                  <div className="d-flex justify-content-end">
                    <svg
                      className="icon ms-4 pe-none caret"
                      width="16"
                      height="17"
                      viewBox="0 0 16 17"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M7.99975 5.29993C8.46642 5.29993 8.93308 5.47993 9.28641 5.83326L13.6331 10.1799C13.8264 10.3733 13.8264 10.6933 13.6331 10.8866C13.4397 11.08 13.1197 11.08 12.9264 10.8866L8.57975 6.54001C8.25975 6.22001 7.73975 6.22001 7.41975 6.54001L3.0731 10.8866C2.87977 11.08 2.55977 11.08 2.36644 10.8866C2.1731 10.6933 2.1731 10.3733 2.36644 10.1799L6.71308 5.83326C7.06642 5.47993 7.53308 5.29993 7.99975 5.29993Z"
                        fill="#A0A0A0"
                      />
                    </svg>
                  </div>
                </li>
                <div
                  className="collapse submenu submenu-items"
                  id={`details-collapse`}
                >
                  <ul className="btn-toggle-nav list-unstyled fw-normal pb-1 small ps-3">
                    {menu.submenu.map((submenu, subIndex) => (
                      <Link to={submenu.link} key={subIndex}>
                        <li className="list-item d-flex px-4" key={subIndex}>
                          {getIconForTitle(submenu.title)}
                          <p className="m-0">{submenu.title}</p>
                        </li>
                      </Link>
                    ))}
                  </ul>
                </div>
              </div>
            );
          } else if (!menu.role) {
            return (
              <Link to={menu.link} key={index}>
                <li
                  key={index}
                  onClick={() => {
                    setSelectedIndex(index);
                  }}
                  className={
                    (index === selectedIndex ? "selected-listitem " : "") +
                    "list-item d-flex align-items-center py-sm-3 py-2 px-4  mb-3"
                  }
                >
                  {getIconForTitle(menu.title)}
                  <p className="m-0 fw-bold pe-none">{menu.title}</p>
                </li>
              </Link>
            );
          } else {
            const roleMenus = menus.filter((item) => item.role === menu.role);
            return (
              <div key={index}>
                <li
                  key={index}
                  className="list-item d-flex align-items-center py-sm-3 py-2 px-4 pe-5 collapsed position-relative submenu-item"
                  data-bs-toggle="collapse"
                  data-bs-target={`#${menu.role}-collapse`}
                >
                  {getIconForTitle(menu.role)}
                  <p className="m-0 fw-bold pe-none submenu-role">
                    {menu.role}
                  </p>
                  <div className="d-flex justify-content-end">
                    <svg
                      className="icon ms-4 pe-none caret"
                      width="16"
                      height="17"
                      viewBox="0 0 16 17"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M7.99975 5.29993C8.46642 5.29993 8.93308 5.47993 9.28641 5.83326L13.6331 10.1799C13.8264 10.3733 13.8264 10.6933 13.6331 10.8866C13.4397 11.08 13.1197 11.08 12.9264 10.8866L8.57975 6.54001C8.25975 6.22001 7.73975 6.22001 7.41975 6.54001L3.0731 10.8866C2.87977 11.08 2.55977 11.08 2.36644 10.8866C2.1731 10.6933 2.1731 10.3733 2.36644 10.1799L6.71308 5.83326C7.06642 5.47993 7.53308 5.29993 7.99975 5.29993Z"
                        fill="#A0A0A0"
                      />
                    </svg>
                  </div>
                </li>
                <div
                  key={`submenu-${index}`}
                  className="collapse submenu submenu-items"
                  id={`${menu.role}-collapse`}
                >
                  <ul className="btn-toggle-nav list-unstyled fw-normal pb-1 small ps-3">
                    {roleMenus.map((submenu, subIndex) => (
                      <Link to={submenu.link} key={subIndex}>
                        <li className="list-item d-flex px-4" key={subIndex}>
                          {getIconForTitle(submenu.title)}
                          <p className="m-0">{submenu.title}</p>
                        </li>
                      </Link>
                    ))}
                  </ul>
                </div>
              </div>
            );
          }
        })}

        <LogoutButton preset={"sidebar"} />
      </ul>
    </div>
  );
};

export default DashboardSideBar;
